module.exports = __webpack_public_path__ + "img/fundowp.5a2fcb3b.jpg";